var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.value.side == _vm.EMPLOYMENT_FIELD_SIDES.DOCUMENT.value ? [_c('img', _vm._b({
    staticStyle: {
      "max-width": "100%"
    }
  }, 'img', {
    src: _vm.src
  }, false))] : [false ? void 0 : _vm.mode == 'done' ? [_c('img', _vm._b({
    staticStyle: {
      "max-width": "100%"
    }
  }, 'img', {
    src: _vm.src
  }, false))] : _vm.mode == 'sign' ? [_c('node-edit', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-card', _vm._g(_vm._b({
          staticClass: "d-flex justify-center align-center",
          attrs: {
            "flat": "",
            "tile": "",
            "width": "100%",
            "height": "100%",
            "color": "transparent"
          }
        }, 'v-card', attrs, false), on), [_c('v-img', _vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-img', {
          src: _vm.src
        }, false), [!_vm.src ? [_c('span', {
          staticStyle: {
            "opacity": "0.5",
            "word-break": "auto-phrase"
          }
        }, [_vm._v(" " + _vm._s(_vm.value.term) + " ")])] : _vm._e()], 2)], 1)];
      }
    }])
  }, 'node-edit', {
    value: _vm.value,
    width: 480
  }, false), {
    sync: _vm.sync,
    emit: _vm.emit
  }), [_c('node-sign-form', _vm._g({
    model: {
      value: _vm.form.img,
      callback: function ($$v) {
        _vm.$set(_vm.form, "img", $$v);
      },
      expression: "form.img"
    }
  }, {
    sync: _vm.sync
  }))], 1)] : [_c('span', {
    staticStyle: {
      "opacity": "0.5",
      "word-break": "auto-phrase"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.term) + " ")])]]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }